export { Model as GenericAnalysisResults } from './model'
export { Store as GenericAnalysisResultsStore } from './store'
